export default `
{{#isTool}}
    <a href="{{ ctaUrl }}" class="tool tool--bordered flag push--bottom">
        <div class="flag__img">
            <svg class="hero-home__select__icon icon">
                <use xmlns:xlink="http://www.w3.org/1999/xlink"
                 xlink:href="#{{icon}}"></use>
            </svg>
        </div>
        <div class="flag__body">
            <h4>{{ title }}</h4>
            <p>{{ ctaText }}</p>
        </div>
    </a>
{{/isTool}}

{{^isTool}}
    <a class="search-result {{#type}}search-result--{{ type }}{{/type}}"
       href="{{ absoluteUri }}">
        <div class="search-result__body">
            <div class="search-result__header">
                {{#type}}
                    <span class="search-result__type">
                        {{{ type }}}
                    </span>
                {{/type}}
                <div class="search-result__title">
                    {{{ _highlightResult.title.value }}}
                </div>
            </div>
            {{#_highlightResult.seo.description.value}}
                <div class="search-result__summary">
                    {{{ _highlightResult.seo.description.value }}}
                </div>
            {{/_highlightResult.seo.description.value}}
        </div>
    </a>
{{/isTool}}
`;
